import { render, staticRenderFns } from "./resulttable.vue?vue&type=template&id=29573c45&scoped=true&"
import script from "./resulttable.vue?vue&type=script&lang=js&"
export * from "./resulttable.vue?vue&type=script&lang=js&"
import style0 from "./resulttable.vue?vue&type=style&index=0&lang=css&"
import style1 from "./resulttable.vue?vue&type=style&index=1&id=29573c45&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29573c45",
  null
  
)

export default component.exports